import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  standalone: false
})
export class ErrorComponent {

  verMsjError: boolean = false;
  msgError: string = 'Lamentablemente, no podemos continuar la operación.';
  constructor(
    private readonly activeRoute: ActivatedRoute,) {
    this.activeRoute.queryParams.subscribe(params => {
      if (params['tipo'] != null && params['tipo'] != undefined && params['tipo'] != '') {
        this.verMsjError = true;
        this.msgError = 'La sesión ha caducado. Por favor, inicie el proceso nuevamente con un nuevo enlace.';
      }
    });
  }
}
